module.exports = __webpack_public_path__ + "static/media/unboxing_goodypack_left.ce29e38f.jpg";